var exports = {
  "kL": "VoiceMessagePlayer.module__container___V3lJMk",
  "Kd": "VoiceMessagePlayer.module__containerActive___V3lJMk",
  "hd": "VoiceMessagePlayer.module__waveformBar___V3lJMk",
  "x5": "VoiceMessagePlayer.module__waveformBarPast___V3lJMk",
  "Rr": "VoiceMessagePlayer.module__playButton___V3lJMk",
  "CJ": "VoiceMessagePlayer.module__playButtonIcon___V3lJMk",
  "S": "VoiceMessagePlayer.module__loadingSpinner___V3lJMk",
  "t0": "VoiceMessagePlayer.module__spin___V3lJMk",
  "FU": "VoiceMessagePlayer.module__waveformContainer___V3lJMk",
  "vE": "VoiceMessagePlayer.module__timestamp___V3lJMk",
  "NS": "VoiceMessagePlayer.module__speedControl___V3lJMk",
  "Wq": "VoiceMessagePlayer.module__volumeControl___V3lJMk",
};

module.exports = exports;
